<template>
  <v-container
    id="detalhe-valor-receber-form"
    fluid
    tag="section"
    class="px-3 pt-0"
    style="margin-top: 1rem"
  >
    <v-row v-if="!paginaEnable">
      <h1 style="display: none">
        Usuário não tem permissão a essa página não existente
      </h1>
    </v-row>
    <v-row v-else>
      <v-col
        cols="12"
        lg="12"
        class="px-1"
      >
        <dashboard-filtro-datas
          :primeiro="enablePrimeiroDia"
          :ultimo="enableUltimoDia"
          :empresas="enableEmpresa"
          :cliente="enableClientes"
          :url="link"
        />
        <v-divider class="mb-5" />
        <v-row>
          <v-col
            cols="12"
            class="container"
          >
            <v-row>
              <v-col
                cols="12"
                sm="12"
                md="12"
                lg="12"
              >
                <div>
                  <v-row>
                    <v-col
                      cols="11"
                    >
                      <h3 class="text-center">
                        Relação de valores recebidos
                      </h3>
                    </v-col>
                  </v-row>
                  <v-row v-if="loading">
                    <v-col
                      cols="12"
                      sm="12"
                      md="12"
                      lg="12"
                    >
                      <div
                        :style="styleObject"
                        class="text-center"
                      >
                        <v-icon
                          light
                          class="custom-loader"
                          :style="styleObject"
                        >
                          mdi-cached
                        </v-icon>
                        Carregando dados...
                      </div>
                    </v-col>
                  </v-row>
                  <v-row v-else-if="error">
                    <v-col
                      cols="12"
                      sm="12"
                      md="12"
                      lg="12"
                    >
                      <div
                        class="alert alert-danger"
                      >
                        {{ error }}
                      </div>
                    </v-col>
                  </v-row>
                  <v-row v-else>
                    <v-col
                      cols="12"
                      sm="12"
                      md="12"
                      lg="12"
                    >
                      <div
                        id="idTable"
                        style="overflow-x: auto; max-width: 100%;"
                      >
                        <table
                          style="width: 100%; color: black; border-collapse: collapse;"
                          class="elevation-1"
                        >
                          <thead>
                            <tr>
                              <th
                                id="dadoMovimentacaoHeader"
                                style="text-align: center; width: 19%;"
                                class="black--text title"
                              >
                                Categoria
                              </th>
                              <th
                                id="dadoMovimentacaoHeader"
                                style="text-align: center;  width: 43%;"
                                class="black--text title"
                              >
                                Nome reduzido
                              </th>
                              <th
                                id="dadoMovimentacaoHeader"
                                style="text-align: center; width: 19%;"
                                class="black--text title"
                              >
                                Codigo Conta Corrente
                              </th>
                              <th
                                id="dadoMovimentacaoHeader"
                                style="text-align: center; width: 19%;"
                                class="black--text title"
                              >
                                Valor Recebido
                              </th>
                            </tr>
                          </thead>
                          <tbody>
                            <tr
                              v-for="item in dadosDetalhamento"
                              :key="item.id"
                              style="cursor: pointer;"
                            >
                              <td
                                id="dadoMovimentacao"
                                style="text-align: left; width: 19%;"
                              >
                                <v-icon
                                  id="iconInformationValorVencido"
                                  class="text-left"
                                  :style="styleObjectIcon"
                                  @click="expandedCategoria(item.categoria)"
                                >
                                  {{ iconeCategoria }}
                                </v-icon>
                                {{ item.categoria }}
                              </td>
                              <td
                                id="dadoMovimentacao"
                                style="text-align: left;  width: 43%;"
                              >
                                <v-icon
                                  id="iconInformationValorVencido"
                                  class="text-left"
                                  :style="styleObjectIcon"
                                  @click="expandedNome(item.nome_reduzido)"
                                >
                                  {{ iconeNome }}
                                </v-icon>
                                {{ item.nome_reduzido }}
                              </td>
                              <td
                                id="dadoMovimentacao"
                                style="text-align: center; width: 19%;"
                              >
                                <v-icon
                                  id="iconInformationValorVencido"
                                  class="text-left"
                                  :style="styleObjectIcon"
                                  @click="expandedConta(item.cod_conta)"
                                >
                                  {{ iconeConta }}
                                </v-icon>
                                {{ item.cod_conta }}
                              </td>
                              <td
                                id="dadoMovimentacao"
                                style="text-align: right; width: 19%;"
                              >
                                {{ item.pago }}
                              </td>
                            </tr>
                          </tbody>
                        </table>
                      </div>
                      <div
                        v-if="expandCategoria"
                        id="idTable"
                        style="overflow-x: auto; max-width: 100%;"
                      >
                        <table
                          style="width: 100%; color: black; border-collapse: collapse;"
                          class="elevation-1"
                        >
                          <thead>
                            <tr>
                              <th
                                id="dadoMovimentacaoHeader"
                                style="text-align: center; width: 19%;"
                                class="black--text title"
                              >
                                Categoria
                              </th>
                              <th
                                id="dadoMovimentacaoHeader"
                                style="text-align: center;  width: 43%;"
                                class="black--text title"
                              >
                                Nome reduzido
                              </th>
                              <th
                                id="dadoMovimentacaoHeader"
                                style="text-align: center; width: 19%;"
                                class="black--text title"
                              >
                                Codigo Conta Corrente
                              </th>
                              <th
                                id="dadoMovimentacaoHeader"
                                style="text-align: center; width: 19%;"
                                class="black--text title"
                              >
                                Valor Recebido
                              </th>
                            </tr>
                          </thead>
                          <tbody>
                            <tr
                              v-for="item in dadosDetalhamentoCategoria"
                              :key="item.id"
                              style="cursor: pointer;"
                            >
                              <td
                                id="dadoMovimentacao"
                                style="text-align: left; width: 19%;"
                              >
                                {{ item.categoria }}
                              </td>
                              <td
                                id="dadoMovimentacao"
                                style="text-align: left;  width: 43%;"
                              >
                                {{ item.nome_reduzido }}
                              </td>
                              <td
                                id="dadoMovimentacao"
                                style="text-align: center; width: 19%;"
                              >
                                {{ item.cod_conta }}
                              </td>
                              <td
                                id="dadoMovimentacao"
                                style="text-align: right; width: 19%;"
                              >
                                {{ item.pago }}
                              </td>
                            </tr>
                          </tbody>
                        </table>
                      </div>
                      <!-- Tabela detalhamento Categoria Fim -->
                      <!-- Tabela detalhamento Nome Inicio -->
                      <div
                        v-if="expandNome"
                        id="idTable"
                        style="overflow-x: auto; max-width: 100%;"
                      >
                        <table
                          style="width: 100%; color: black; border-collapse: collapse;"
                          class="elevation-1"
                        >
                          <thead>
                            <tr>
                              <th
                                id="dadoMovimentacaoHeader"
                                style="text-align: center; width: 19%;"
                                class="black--text title"
                              >
                                Categoria
                              </th>
                              <th
                                id="dadoMovimentacaoHeader"
                                style="text-align: center;  width: 43%;"
                                class="black--text title"
                              >
                                Nome reduzido
                              </th>
                              <th
                                id="dadoMovimentacaoHeader"
                                style="text-align: center; width: 19%;"
                                class="black--text title"
                              >
                                Codigo Conta Corrente
                              </th>
                              <th
                                id="dadoMovimentacaoHeader"
                                style="text-align: center; width: 19%;"
                                class="black--text title"
                              >
                                Valor Recebido
                              </th>
                            </tr>
                          </thead>
                          <tbody>
                            <tr
                              v-for="item in dadosDetalhamentoNome"
                              :key="item.id"
                              style="cursor: pointer;"
                            >
                              <td
                                id="dadoMovimentacao"
                                style="text-align: left; width: 19%;"
                              >
                                {{ item.categoria }}
                              </td>
                              <td
                                id="dadoMovimentacao"
                                style="text-align: left;  width: 43%;"
                              >
                                {{ item.nome_reduzido }}
                              </td>
                              <td
                                id="dadoMovimentacao"
                                style="text-align: center; width: 19%;"
                              >
                                {{ item.cod_conta }}
                              </td>
                              <td
                                id="dadoMovimentacao"
                                style="text-align: right; width: 19%;"
                              >
                                {{ item.pago }}
                              </td>
                            </tr>
                          </tbody>
                        </table>
                      </div>
                      <!-- Tabela detalhamento Nome Fim -->
                      <!-- Tabela detalhamento Conta Inicio -->
                      <div
                        v-if="expandConta"
                        id="idTable"
                        style="overflow-x: auto; max-width: 100%;"
                      >
                        <table
                          style="width: 100%; color: black; border-collapse: collapse;"
                          class="elevation-1"
                        >
                          <thead>
                            <tr>
                              <th
                                id="dadoMovimentacaoHeader"
                                style="text-align: center; width: 19%;"
                                class="black--text title"
                              >
                                Categoria
                              </th>
                              <th
                                id="dadoMovimentacaoHeader"
                                style="text-align: center;  width: 43%;"
                                class="black--text title"
                              >
                                Nome reduzido
                              </th>
                              <th
                                id="dadoMovimentacaoHeader"
                                style="text-align: center; width: 19%;"
                                class="black--text title"
                              >
                                Codigo Conta Corrente
                              </th>
                              <th
                                id="dadoMovimentacaoHeader"
                                style="text-align: center; width: 19%;"
                                class="black--text title"
                              >
                                Valor Recebido
                              </th>
                            </tr>
                          </thead>
                          <tbody>
                            <tr
                              v-for="item in dadosDetalhamentoConta"
                              :key="item.id"
                              style="cursor: pointer;"
                            >
                              <td
                                id="dadoMovimentacao"
                                style="text-align: left; width: 19%;"
                              >
                                {{ item.categoria }}
                              </td>
                              <td
                                id="dadoMovimentacao"
                                style="text-align: left;  width: 43%;"
                              >
                                {{ item.nome_reduzido }}
                              </td>
                              <td
                                id="dadoMovimentacao"
                                style="text-align: center; width: 19%;"
                              >
                                {{ item.cod_conta }}
                              </td>
                              <td
                                id="dadoMovimentacao"
                                style="text-align: right; width: 19%;"
                              >
                                {{ item.pago }}
                              </td>
                            </tr>
                          </tbody>
                        </table>
                      </div>
                      <!-- Tabela detalhamento Conta Fim -->
                      <!-- Tabela detalhamento categoria e nome Inicio -->
                      <div
                        v-if="expandCategoriaNome"
                        id="idTable"
                        style="overflow-x: auto; max-width: 100%;"
                      >
                        <table
                          style="width: 100%; color: black; border-collapse: collapse;"
                          class="elevation-1"
                        >
                          <thead>
                            <tr>
                              <th
                                id="dadoMovimentacaoHeader"
                                style="text-align: center; width: 19%;"
                                class="black--text title"
                              >
                                Categoria
                              </th>
                              <th
                                id="dadoMovimentacaoHeader"
                                style="text-align: center;  width: 43%;"
                                class="black--text title"
                              >
                                Nome reduzido
                              </th>
                              <th
                                id="dadoMovimentacaoHeader"
                                style="text-align: center; width: 19%;"
                                class="black--text title"
                              >
                                Codigo Conta Corrente
                              </th>
                              <th
                                id="dadoMovimentacaoHeader"
                                style="text-align: center; width: 19%;"
                                class="black--text title"
                              >
                                Valor Recebido
                              </th>
                            </tr>
                          </thead>
                          <tbody>
                            <tr
                              v-for="item in dadosDetalhamentoCategoriaNome"
                              :key="item.id"
                              style="cursor: pointer;"
                            >
                              <td
                                id="dadoMovimentacao"
                                style="text-align: left; width: 19%;"
                              >
                                {{ item.categoria }}
                              </td>
                              <td
                                id="dadoMovimentacao"
                                style="text-align: left;  width: 43%;"
                              >
                                {{ item.nome_reduzido }}
                              </td>
                              <td
                                id="dadoMovimentacao"
                                style="text-align: center; width: 19%;"
                              >
                                {{ item.cod_conta }}
                              </td>
                              <td
                                id="dadoMovimentacao"
                                style="text-align: right; width: 19%;"
                              >
                                {{ item.pago }}
                              </td>
                            </tr>
                          </tbody>
                        </table>
                      </div>
                      <!-- Tabela detalhamento categoria e nome Fim -->
                      <!-- Tabela detalhamento categoria e nome Inicio -->
                      <div
                        v-if="expandCategoriaConta"
                        id="idTable"
                        style="overflow-x: auto; max-width: 100%;"
                      >
                        <table
                          style="width: 100%; color: black; border-collapse: collapse;"
                          class="elevation-1"
                        >
                          <thead>
                            <tr>
                              <th
                                id="dadoMovimentacaoHeader"
                                style="text-align: center; width: 19%;"
                                class="black--text title"
                              >
                                Categoria
                              </th>
                              <th
                                id="dadoMovimentacaoHeader"
                                style="text-align: center;  width: 43%;"
                                class="black--text title"
                              >
                                Nome reduzido
                              </th>
                              <th
                                id="dadoMovimentacaoHeader"
                                style="text-align: center; width: 19%;"
                                class="black--text title"
                              >
                                Codigo Conta Corrente
                              </th>
                              <th
                                id="dadoMovimentacaoHeader"
                                style="text-align: center; width: 19%;"
                                class="black--text title"
                              >
                                Valor Recebido
                              </th>
                            </tr>
                          </thead>
                          <tbody>
                            <tr
                              v-for="item in dadosDetalhamentoCategoriaConta"
                              :key="item.id"
                              style="cursor: pointer;"
                            >
                              <td
                                id="dadoMovimentacao"
                                style="text-align: left; width: 19%;"
                              >
                                {{ item.categoria }}
                              </td>
                              <td
                                id="dadoMovimentacao"
                                style="text-align: left;  width: 43%;"
                              >
                                {{ item.nome_reduzido }}
                              </td>
                              <td
                                id="dadoMovimentacao"
                                style="text-align: center; width: 19%;"
                              >
                                {{ item.cod_conta }}
                              </td>
                              <td
                                id="dadoMovimentacao"
                                style="text-align: right; width: 19%;"
                              >
                                {{ item.pago }}
                              </td>
                            </tr>
                          </tbody>
                        </table>
                      </div>
                      <!-- Tabela detalhamento categoria e nome Fim -->
                      <!-- Tabela detalhamento nome e conta Inicio -->
                      <div
                        v-if="expandNomeConta"
                        id="idTable"
                        style="overflow-x: auto; max-width: 100%;"
                      >
                        <table
                          style="width: 100%; color: black; border-collapse: collapse;"
                          class="elevation-1"
                        >
                          <thead>
                            <tr>
                              <th
                                id="dadoMovimentacaoHeader"
                                style="text-align: center; width: 19%;"
                                class="black--text title"
                              >
                                Categoria
                              </th>
                              <th
                                id="dadoMovimentacaoHeader"
                                style="text-align: center;  width: 43%;"
                                class="black--text title"
                              >
                                Nome reduzido
                              </th>
                              <th
                                id="dadoMovimentacaoHeader"
                                style="text-align: center; width: 19%;"
                                class="black--text title"
                              >
                                Codigo Conta Corrente
                              </th>
                              <th
                                id="dadoMovimentacaoHeader"
                                style="text-align: center; width: 19%;"
                                class="black--text title"
                              >
                                Valor Recebido
                              </th>
                            </tr>
                          </thead>
                          <tbody>
                            <tr
                              v-for="item in dadosDetalhamentoNomeConta"
                              :key="item.id"
                              style="cursor: pointer;"
                            >
                              <td
                                id="dadoMovimentacao"
                                style="text-align: left; width: 19%;"
                              >
                                {{ item.categoria }}
                              </td>
                              <td
                                id="dadoMovimentacao"
                                style="text-align: left;  width: 43%;"
                              >
                                {{ item.nome_reduzido }}
                              </td>
                              <td
                                id="dadoMovimentacao"
                                style="text-align: center; width: 19%;"
                              >
                                {{ item.cod_conta }}
                              </td>
                              <td
                                id="dadoMovimentacao"
                                style="text-align: right; width: 19%;"
                              >
                                {{ item.pago }}
                              </td>
                            </tr>
                          </tbody>
                        </table>
                      </div>
                      <!-- Tabela detalhamento nome e conta Fim -->
                      <!-- Tabela detalhamento categoria, nome e conta Inicio -->
                      <div
                        v-if="expandCategoriaNomeConta"
                        id="idTable"
                        style="overflow-x: auto; max-width: 100%;"
                      >
                        <table
                          style="width: 100%; color: black; border-collapse: collapse;"
                          class="elevation-1"
                        >
                          <thead>
                            <tr>
                              <th
                                id="dadoMovimentacaoHeader"
                                style="text-align: center; width: 19%;"
                                class="black--text title"
                              >
                                Categoria
                              </th>
                              <th
                                id="dadoMovimentacaoHeader"
                                style="text-align: center;  width: 43%;"
                                class="black--text title"
                              >
                                Nome reduzido
                              </th>
                              <th
                                id="dadoMovimentacaoHeader"
                                style="text-align: center; width: 19%;"
                                class="black--text title"
                              >
                                Codigo Conta Corrente
                              </th>
                              <th
                                id="dadoMovimentacaoHeader"
                                style="text-align: center; width: 19%;"
                                class="black--text title"
                              >
                                Valor Recebido
                              </th>
                            </tr>
                          </thead>
                          <tbody>
                            <tr
                              v-for="item in dadosDetalhamentoCategoriaNomeConta"
                              :key="item.id"
                              style="cursor: pointer;"
                            >
                              <td
                                id="dadoMovimentacao"
                                style="text-align: left; width: 19%;"
                              >
                                {{ item.categoria }}
                              </td>
                              <td
                                id="dadoMovimentacao"
                                style="text-align: left;  width: 43%;"
                              >
                                {{ item.nome_reduzido }}
                              </td>
                              <td
                                id="dadoMovimentacao"
                                style="text-align: center; width: 19%;"
                              >
                                {{ item.cod_conta }}
                              </td>
                              <td
                                id="dadoMovimentacao"
                                style="text-align: right; width: 19%;"
                              >
                                {{ item.pago }}
                              </td>
                            </tr>
                          </tbody>
                        </table>
                      </div>
                      <!-- Tabela detalhamento categoria, nome e conta Fim -->
                    </v-col>
                  </v-row>
                </div>
              </v-col>
            </v-row>
          </v-col>
        </v-row>
      </v-col>
    </v-row>
    <dashboard-core-snackbar
      v-model="snackbar.visible"
      :visible="snackbar.visible"
      :timeout="snackbar.timeout"
      :color="snackbar.color"
      :message="snackbar.message"
    />
  </v-container>
</template>

<script>
  import ContasReceber from '../../../../../services/contasreceber'
  import eventEmit from '../../../components/core/EventoEmit'

  export default {
    name: 'DashboardContasAReceberDetalhamento',
    // emits: ['setDadosDetalhamento'],
    components: {
      DashboardFiltroDatas: () => import('../../../components/core/FiltroDatas'),
      DashboardCoreSnackbar: () => import('../../../components/core/Snackbar'),
    },

    data: () => ({
      appOnline: navigator.onLine,
      corPrimaria: localStorage.corPrimaria,
      corSecondaria: localStorage.corSecondaria,
      styleObjectIcon: {
        color: '#4780b8',
      },
      styleObject: {
        color: localStorage.corPrimaria,
      },
      enablePrimeiroDia: true,
      enableUltimoDia: true,
      enableEmpresa: true,
      enableClientes: true,
      link: localStorage.linkContasReceber,
      paginaEnable: false,
      permissaoContasReceber: '',
      primeiroDia: (new Date(new Date().getFullYear(), new Date().getMonth(), 1)).toISOString().substr(0, 10),
      ultimoDia: (new Date(new Date().getFullYear(), new Date().getMonth() + 1, 0)).toISOString().substr(0, 10),
      select: [],
      selectClientes: [],
      headersDetalhamento: [
        { text: 'Categoria', value: 'categoria', width: '18%', class: 'black--text title' },
        { text: 'Nome reduzido', value: 'nome_reduzido', width: '28%', align: 'left', class: 'black--text title' },
        { text: 'Codigo Conta Corrente', value: 'cod_conta', width: '23%', align: 'left', class: 'black--text title' },
        { text: 'Valor Recebido', value: 'pago', width: '25%', align: 'right', class: 'black--text title' },
      ],
      dadosDetalhamento: [],
      dadosDetalhamentoCategoria: [],
      dadosDetalhamentoNome: [],
      dadosDetalhamentoConta: [],
      dadosDetalhamentoCategoriaNome: [],
      dadosDetalhamentoCategoriaConta: [],
      dadosDetalhamentoNomeConta: [],
      dadosDetalhamentoCategoriaNomeConta: [],
      respostaDetalheCategoria: [],
      respostaDetalheNome: [],
      respostaDetalheConta: [],
      respostaDetalheCategoriaNome: [],
      respostaDetalheCategoriaConta: [],
      respostaDetalheNomeConta: [],
      respostaDetalheCategoriaNomeConta: [],
      iconeCategoria: 'mdi-plus',
      iconeNome: 'mdi-plus',
      iconeConta: 'mdi-plus',
      expandCategoria: false,
      expandNome: false,
      expandConta: false,
      expandCategoriaNome: false,
      expandCategoriaConta: false,
      expandCategoriaNomeConta: false,
      expandNomeConta: false,
      loading: false,
      error: null,
      snackbar: {
        visible: false,
        color: 'success',
        direction: 'top center',
        message: 'My timeout is set to 3000.',
        timeout: 3000,
      },
    }),

    created () {
      eventEmit.$on('update-dados', this.handleUpdateDados)
    },

    beforeDestroy () {
      eventEmit.$off('update-dados', this.handleUpdateDados)
    },

    mounted () {
      if (localStorage.tokencontrato) {
        this.usuarioIdentificado = true

        this.paginaEnable = true
      } else {
        this.usuarioIdentificado = false
        localStorage.removeItem('username')
        localStorage.removeItem('email')
        localStorage.removeItem('nome')
        localStorage.removeItem('usuarioIdentificado')
        this.$router.push('/login')
      }
    },

    methods: {
      handleUpdateDados (primeiroDia, dataFinal, select, selectVendedores, selectArea, selectRede, selectSupervisor, selectReceita, selectSegmento, selectClassificacao, selectProduto, selectCidade, selectCategoria, selectPromotor, selectLinhasProducao, primeiroDiaStatus, dateStatus, selectMotorista, selectStatusEntrega, selectOrdem, selectOpcaoOrdenacao, selectOrientacaoOrdem, selectClientes) {
        this.primeiroDia = primeiroDia
        this.ultimoDia = dataFinal
        this.select = select
        this.selectClientes = selectClientes

        this.updateDate()
      },

      updateDate () {
        this.dadosDetalhamento = []
        this.dadosDetalhamentoCategoria = []
        this.dadosDetalhamentoNome = []
        this.dadosDetalhamentoConta = []
        this.dadosDetalhamentoCategoriaNome = []
        this.dadosDetalhamentoCategoriaConta = []
        this.dadosDetalhamentoNomeConta = []
        this.dadosDetalhamentoCategoriaNomeConta = []

        this.respostaDetalheCategoria = []
        this.respostaDetalheNome = []
        this.respostaDetalheConta = []
        this.respostaDetalheCategoriaNome = []
        this.respostaDetalheCategoriaConta = []
        this.respostaDetalheNomeConta = []
        this.respostaDetalheCategoriaNomeConta = []

        this.showContasReceberDelhamentoValorRecebido()
      },

      async showContasReceberDelhamentoValorRecebido () {
        this.loading = true

        await ContasReceber.showDelhamentoValorRecebido(this.primeiroDia, this.ultimoDia, this.select, localStorage.tokencontrato, this.selectClientes).then(resposta => {
          if (resposta.data.status) {
            this.dadosDetalhamento = resposta.data.dadosExibicao.map((item) => {
              var listaDetalhamento = ({
                categoria: item.categoria,
                nome_reduzido: item.nome_reduzido,
                cod_conta: item.cod_conta,
                pago: parseFloat(item.pago).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' }),
              })

              return listaDetalhamento
            })

            this.showRespostaDetalheCategoria(resposta.data.dadosDetalheCategoria)

            this.showRespostaDetalheNome(resposta.data.dadosDetalheNome)

            this.showRespostaDetalheConta(resposta.data.dadosDetalheConta)

            this.showRespostaDetalheCategoriaNome(resposta.data.dadosDetalheCategoriaNome)

            this.showRespostaDetalheCategoriaConta(resposta.data.dadosDetalheCategoriaConta)

            this.showRespostaDetalheNomeConta(resposta.data.dadosDetalheNomeConta)

            this.showRespostaDetalheCategoriaNomeConta(resposta.data.dadosDetalheCategoriaNomeConta)
          } else if (resposta.data.msg === 'Não há dados de recebimento no período selecionado') {
            this.dadosDetalhamento = []

            this.showSnackbar('error', 3000, resposta.data.msg)
          }
        }).catch(e => {
          if (e.message === 'Network Error') {
            this.error = e.message

            this.showSnackbar('error', 3000, 'Falha na conexão com a internet')
          }
        }).finally(f => { this.loading = false })
      },

      showRespostaDetalheCategoria (dados) {
        try {
          this.respostaDetalheCategoria = dados.map((item) => {
            var listaCategoria = ({
              categoria: item.categoria,
              nome_reduzido: item.nome_reduzido,
              cod_conta: item.cod_conta,
              pago: parseFloat(item.pago).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' }),
            })

            return listaCategoria
          })
        } catch (error) {
          this.showSnackbar('error', 3000, 'Falha ao montar dados detalhe categoria: ' + error)
        }
      },

      showRespostaDetalheNome (dados) {
        try {
          this.respostaDetalheNome = dados.map((item) => {
            var listaCategoria = ({
              categoria: item.categoria,
              nome_reduzido: item.nome_reduzido,
              cod_conta: item.cod_conta,
              pago: parseFloat(item.pago).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' }),
            })

            return listaCategoria
          })
        } catch (error) {
          this.showSnackbar('error', 3000, 'Falha ao montar dados detalhe nome: ' + error)
        }
      },

      showRespostaDetalheConta (dados) {
        try {
          this.respostaDetalheConta = dados.map((item) => {
            var listaCategoria = ({
              categoria: item.categoria,
              nome_reduzido: item.nome_reduzido,
              cod_conta: item.cod_conta,
              pago: parseFloat(item.pago).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' }),
            })

            return listaCategoria
          })
        } catch (error) {
          this.showSnackbar('error', 3000, 'Falha ao montar dados detalhe conta: ' + error)
        }
      },

      showRespostaDetalheCategoriaNome (dados) {
        try {
          this.respostaDetalheCategoriaNome = dados.map((item) => {
            var listaCategoria = ({
              categoria: item.categoria,
              nome_reduzido: item.nome_reduzido,
              cod_conta: item.cod_conta,
              pago: parseFloat(item.pago).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' }),
            })

            return listaCategoria
          })
        } catch (error) {
          this.showSnackbar('error', 3000, 'Falha ao montar dados detalhe categoria/nome: ' + error)
        }
      },

      showRespostaDetalheCategoriaConta (dados) {
        try {
          this.respostaDetalheCategoriaConta = dados.map((item) => {
            var listaCategoria = ({
              categoria: item.categoria,
              nome_reduzido: item.nome_reduzido,
              cod_conta: item.cod_conta,
              pago: parseFloat(item.pago).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' }),
            })

            return listaCategoria
          })
        } catch (error) {
          this.showSnackbar('error', 3000, 'Falha ao montar dados detalhe categoria/conta: ' + error)
        }
      },

      showRespostaDetalheNomeConta (dados) {
        try {
          this.respostaDetalheNomeConta = dados.map((item) => {
            var listaCategoria = ({
              categoria: item.categoria,
              nome_reduzido: item.nome_reduzido,
              cod_conta: item.cod_conta,
              pago: parseFloat(item.pago).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' }),
            })

            return listaCategoria
          })
        } catch (error) {
          this.showSnackbar('error', 3000, 'Falha ao montar dados detalhe nome/conta: ' + error)
        }
      },

      showRespostaDetalheCategoriaNomeConta (dados) {
        try {
          this.respostaDetalheCategoriaNomeConta = dados.map((item) => {
            var listaCategoria = ({
              categoria: item.categoria,
              nome_reduzido: item.nome_reduzido,
              cod_conta: item.cod_conta,
              pago: parseFloat(item.pago).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' }),
            })

            return listaCategoria
          })
        } catch (error) {
          this.showSnackbar('error', 3000, 'Falha ao montar dados detalhe categoria/nome/conta: ' + error)
        }
      },

      async expandedCategoria (value) {
        if (!this.expandCategoria) {
          this.iconeCategoria = 'mdi-minus'

          if (this.expandCategoriaNomeConta && this.iconeNome === 'mdi-minus' && this.iconeConta === 'mdi-minus') {
            this.iconeCategoria = 'mdi-plus'
            this.expandCategoriaNomeConta = false
            this.expandNome = false
            this.expandConta = false
            this.expandCategoriaNome = false

            this.expandedNomeConta(value)
          } else if (this.iconeNome === 'mdi-minus' && this.iconeConta === 'mdi-minus') {
            this.expandedCategoriaNomeConta(value)
          } else if (this.expandCategoriaNome && this.iconeNome === 'mdi-minus') {
            this.iconeCategoria = 'mdi-plus'
            this.expandCategoria = false
            this.expandCategoriaNome = false
            this.expandNome = true

            this.dadosDetalhamentoNome = []

            this.loading = true

            try {
              this.dadosDetalhamentoNome = this.respostaDetalheNome
            } finally {
              setTimeout(() => {
                this.loading = false
              }, 500)
            }
          } else if (this.expandCategoriaConta && this.iconeConta === 'mdi-minus') {
            this.expandCategoriaConta = false
            this.expandCategoria = false
            this.expandConta = true
            this.dadosDetalhamentoCategoriaConta = []
            this.iconeCategoria = 'mdi-plus'

            this.loading = true

            try {
              this.dadosDetalhamentoConta = this.respostaDetalheConta
            } finally {
              setTimeout(() => {
                this.loading = false
              }, 500)
            }
          } else if (this.iconeConta === 'mdi-minus') {
            this.expandedCategoriaConta(value)
          } else if (this.iconeNome === 'mdi-minus') {
            this.expandedCategoriaNome(value)
          } else {
            this.expandCategoria = true
            this.dadosDetalhamentoCategoria = []

            this.loading = true

            try {
              this.dadosDetalhamentoCategoria = this.respostaDetalheCategoria
            } finally {
              setTimeout(() => {
                this.loading = false
              }, 500)
            }
          }
        } else {
          this.dadosDetalhamentoCategoria = []
          this.expandCategoria = false
          this.iconeCategoria = 'mdi-plus'
        }
      },

      async expandedNome (value) {
        if (!this.expandNome) {
          this.iconeNome = 'mdi-minus'

          if (this.expandCategoriaNomeConta && this.iconeCategoria === 'mdi-minus' && this.iconeConta === 'mdi-minus') {
            this.iconeNome = 'mdi-plus'
            this.expandCategoriaNomeConta = false
            this.expandNome = false
            this.expandConta = false
            this.expandCategoriaConta = false

            this.expandedCategoriaConta(value)
          } else if (this.iconeCategoria === 'mdi-minus' && this.iconeConta === 'mdi-minus') {
            this.expandedCategoriaNomeConta(value)
          } else if (this.expandCategoriaNome && this.iconeCategoria === 'mdi-minus') {
            this.iconeNome = 'mdi-plus'
            this.expandCategoriaNome = false
            this.expandNome = false
            this.expandCategoria = true

            this.loading = true

            try {
              this.dadosDetalhamentoCategoria = this.respostaDetalheCategoria
            } finally {
              setTimeout(() => {
                this.loading = false
              }, 500)
            }
          } else if (this.expandNomeConta && this.iconeConta === 'mdi-minus') {
            this.expandNomeConta = false
            this.expandNome = false
            this.expandConta = true
            this.iconeNome = 'mdi-plus'
            this.dadosDetalhamentoNomeConta = []

            this.loading = true

            try {
              this.dadosDetalhamentoConta = this.respostaDetalheConta
            } finally {
              setTimeout(() => {
                this.loading = false
              }, 500)
            }
          } else if (this.iconeConta === 'mdi-minus') {
            this.expandedNomeConta(value)
          } else if (this.iconeCategoria === 'mdi-minus') {
            this.expandedCategoriaNome(value)
          } else {
            this.expandNome = true

            this.loading = true

            try {
              this.dadosDetalhamentoNome = this.respostaDetalheNome
            } finally {
              setTimeout(() => {
                this.loading = false
              }, 500)
            }
          }
        } else {
          this.dadosDetalhamentoNome = []
          this.expandNome = false
          this.iconeNome = 'mdi-plus'
        }
      },

      async expandedConta (value) {
        if (!this.expandConta) {
          this.iconeConta = 'mdi-minus'

          if (this.expandCategoriaNomeConta && this.iconeCategoria === 'mdi-minus' && this.iconeNome === 'mdi-minus') {
            this.iconeConta = 'mdi-plus'
            this.expandCategoriaNomeConta = false
            this.expandNome = false
            this.expandConta = false
            this.expandNomeConta = false

            this.expandedCategoriaNome(value)
          } else if (this.iconeCategoria === 'mdi-minus' && this.iconeNome === 'mdi-minus') {
            this.expandedCategoriaNomeConta(value)
          } else if (this.expandCategoriaConta && this.iconeCategoria === 'mdi-minus') {
            this.iconeConta = 'mdi-plus'
            this.expandCategoria = true
            this.expandCategoriaConta = false
            this.expandConta = false

            this.loading = true

            try {
              this.dadosDetalhamentoCategoria = this.respostaDetalheCategoria
            } finally {
              setTimeout(() => {
                this.loading = false
              }, 500)
            }
          } else if (this.expandNomeConta && this.iconeNome === 'mdi-minus') {
            this.iconeConta = 'mdi-plus'
            this.expandNomeConta = false
            this.expandConta = false
            this.expandCategoria = false
            this.expandNome = true

            this.dadosDetalhamentoNomeConta = []

            this.loading = true

            try {
              this.dadosDetalhamentoNome = this.respostaDetalheNome
            } finally {
              setTimeout(() => {
                this.loading = false
              }, 500)
            }
          } else if (this.iconeNome === 'mdi-minus') {
            this.expandedNomeConta(value)
          } else if (this.iconeCategoria === 'mdi-minus') {
            this.expandedCategoriaConta(value)
          } else {
            this.expandConta = true

            this.loading = true

            try {
              this.dadosDetalhamentoConta = this.respostaDetalheConta
            } finally {
              setTimeout(() => {
                this.loading = false
              }, 500)
            }
          }
        } else {
          this.dadosDetalhamentoConta = []
          this.expandConta = false
          this.iconeConta = 'mdi-plus'
        }
      },

      async expandedCategoriaConta (value) {
        if (this.iconeCategoria === 'mdi-minus' && this.iconeConta === 'mdi-minus') {
          this.expandCategoriaConta = true
          this.expandCategoria = false
          this.expandConta = false

          this.loading = true

          try {
            this.dadosDetalhamentoCategoriaConta = this.respostaDetalheCategoriaConta
          } finally {
            setTimeout(() => {
              this.loading = false
            }, 500)
          }
        }
      },

      async expandedCategoriaNome (value) {
        if (this.iconeCategoria === 'mdi-minus' && this.iconeNome === 'mdi-minus') {
          this.expandCategoriaNome = true
          this.expandNome = false
          this.expandCategoria = false

          this.loading = true

          try {
            this.dadosDetalhamentoCategoriaNome = this.respostaDetalheCategoriaNome
          } finally {
            setTimeout(() => {
              this.loading = false
            }, 500)
          }
        }
      },

      async expandedNomeConta (value) {
        if (this.iconeConta === 'mdi-minus' && this.iconeNome === 'mdi-minus') {
          this.expandNomeConta = true
          this.expandNome = false
          this.expandConta = false

          this.loading = true

          try {
            this.dadosDetalhamentoNomeConta = this.respostaDetalheNomeConta
          } finally {
            setTimeout(() => {
              this.loading = false
            }, 500)
          }
        }
      },

      async expandedCategoriaNomeConta (value) {
        if (this.iconeCategoria === 'mdi-minus' && this.iconeNome === 'mdi-minus' && this.iconeConta === 'mdi-minus') {
          this.expandCategoriaNomeConta = true
          this.expandCategoria = false
          this.expandNome = false
          this.expandConta = false
          this.expandCategoriaNome = false
          this.expandCategoriaConta = false
          this.expandNomeConta = false

          this.loading = true

          try {
            this.dadosDetalhamentoCategoriaNomeConta = this.respostaDetalheCategoriaNomeConta
          } finally {
            setTimeout(() => {
              this.loading = false
            }, 500)
          }
        }
      },
    },
  }
</script>

<style scoped>
  @media screen
  and (min-device-width : 320px)
  and (max-device-width : 680px) {
    #idTable {
      max-height: 500px;
      max-width: 395px !important;
    }

    #dadoMovimentacao {
      font-size: 8.5px;
    }

    th, td {
      padding: 8px;
    }
  }

  @media screen
  and (min-width : 681px)
  and (max-width : 960px)
  and (-webkit-min-device-pixel-ratio: 1) {
  }

  #idTable {
    overflow-x: auto;
    overflow-y: auto;
    max-height: 500px;
  }

  table {
    width: 100%;
    border-collapse: collapse;
    font-family: Roboto, sans-serif;
    border: 1px solid #e0e0e0;
  }

  thead th {
    position: sticky;
    top: 0;
    z-index: 2;
    background-color: #f5f5f5;
  }

  th, td {
    border: 1px solid #e0e0e0;
    padding: 10px;
    color: #424242;
  }

  thead {
    background-color: #f5f5f5;
  }

  tbody tr:hover {
    background-color: #f0f0f0;
  }

  #dadoMovimentacaoHeader {
    font-size: 12px !important;
    font-weight: 800 !important;
  }
</style>

<style lang="sass">
  #bloco1
    margin-left: -5rem

  #templateCategoriaNome
    margin-left: 2rem

  #templateCategoriaConta
    margin-left: -2.9rem

  #templateNomeCategoria
    // margin-left: 5rem

  #templateNome
    margin-left: 15rem

  #templateNomeConta
    margin-left: -31rem

  #templateConta
    margin-left: 38rem

  #templateTableCategoriaNome
    margin-left: 14rem

  #templateTableCategoriaNomeConta
    margin-left: -23.3rem

  #templateCategoriaNomeConta
    margin-left: 36rem

  #templateCategoriaNomePago
    margin-left: 5rem

  .custom-loader
    animation: loader 1s infinite
    display: flex
    @-moz-keyframes loader
      from
        transform: rotate(0)
      to
        transform: rotate(360deg)
    @-webkit-keyframes loader
      from
        transform: rotate(0)
      to
        transform: rotate(360deg)
    @-o-keyframes loader
      from
        transform: rotate(0)
      to
        transform: rotate(360deg)
    @keyframes loader
      from
        transform: rotate(0)
      to
        transform: rotate(360deg)

</style>
